import React from 'react'
import {Route} from 'react-router'
import Layout from './Layout'
import Login from './Login'
import Prelogin from './Prelogin'
import Register from './Register'
import VerifyEmail from './VerifyEmail'
import Forgot from './Forgot'
import Reset from './Reset'
import Enroll from './Enroll'
import LoginToken from './LoginToken'

export default (
  <Route component={Layout}>
    <Route path="/login" component={Login} />
    <Route path="/welcome" component={Prelogin} />
    <Route path="/register" component={Register} />
    <Route path="/verify-email/:token(/:user)(/:id)" component={VerifyEmail} />
    <Route path="/forgot" component={Forgot} />
    <Route path="/reset/:token" component={Reset} />
    <Route path="/enroll/:token" component={Enroll} />
    <Route path="/logintoken" component={LoginToken} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Auth/index.js